import Accordion from 'accordion-js'

import { isMobile, isTablet, isDesktop } from '../functions/check-viewport';
export const bag = () => {

  // Константы для классов
  const BAG = '.bag .main';
  const ITEMS = '.items';
  const ITEM_1 = '.item__1';
  const ITEM_2 = '.item__2';
  const ITEM_3 = '.item__3';
  const BUG_1 = '.bug__1';
  const BUG_2 = '.bug__2';
  const BUG_3 = '.bug__3';
  const READY = '.ready';
  const CHOICES = '.choices';
  const YES = '.yes';
  const NO = '.no';
  const ITEM = '.item';
  const MINUS = '.minus';
  const PLUS = '.plus';
  const BUTTONS = '.buttons';


  const RES_1 = 'result_1'
  const RES_2 = 'result_2'
  const RES_3 = 'result_3'
  const RES_YES_OR_NO = 'yes_no'
  const ARR_RES = [RES_YES_OR_NO, RES_1, RES_2, RES_3]


  // Константы для классов состояний
  const ACTIVE = 'active';
  const ERROR = 'error';

  // Поиск элементов
  const container = document.querySelector(BAG);
  const itemsCont = container.querySelector(ITEMS);
  const itemOne = itemsCont.querySelector(ITEM_1);
  const itemTwo = itemsCont.querySelector(ITEM_2);
  const itemThree = itemsCont.querySelector(ITEM_3);
  const bugOne = container.querySelector(BUG_1);
  const bugTwo = container.querySelector(BUG_2);
  const bugThree = container.querySelector(BUG_3);
  const ready = container.querySelector(READY);
  const choices = container.querySelector(CHOICES);
  const answerError = container.querySelector('.answers__error');

  const yes = choices.querySelector(YES);
  const no = choices.querySelector(NO);
  const items = itemsCont.querySelectorAll(ITEM);

  const result = new Map();

  // Обработчики для "да" и "нет"
  yes.addEventListener('click', () => {
    no.classList.remove(ACTIVE);
    yes.classList.add(ACTIVE);
    result.set(RES_YES_OR_NO, true);
  });

  no.addEventListener('click', () => {
    yes.classList.remove(ACTIVE);
    no.classList.add(ACTIVE);
    result.set(RES_YES_OR_NO, false);
  });

  const scrollToAnswer = (offest) => {
    const buttonPosition = ready.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: buttonPosition - offest,
      behavior: 'smooth'
    });
  }

  // Функция для обработки плюс/минус
  const minusPlus = (item, key) => {
    const minus = item.querySelector(MINUS);
    const plus = item.querySelector(PLUS);

    minus.addEventListener('click', () => {
      plus.classList.remove(ACTIVE);
      minus.classList.add(ACTIVE);
      item.classList.add(ACTIVE);
      result.set(key, false);
    });

    plus.addEventListener('click', () => {
      minus.classList.remove(ACTIVE);
      plus.classList.add(ACTIVE);
      item.classList.add(ACTIVE);
      result.set(key, true);
    });
  };

  // Функция для показа/скрытия бага
  const showBug = (item, key) => {
    if (result.get(key)) {
      item.classList.add(ACTIVE);
    } else {
      item.classList.remove(ACTIVE);
    }

  };

  // Инициализация обработчиков для плюс/минус
  minusPlus(itemOne, RES_1);
  minusPlus(itemTwo, RES_2);
  minusPlus(itemThree, RES_3);

  // Обработчик для кнопки "готово"
  ready.addEventListener('click', () => {
    console.log(result);

    items.forEach((item) => {
      if (!item.classList.contains(ACTIVE)) {
        item.querySelector(BUTTONS).classList.add(ERROR);
      } else {
        item.querySelector(BUTTONS).classList.remove(ERROR);
      }
    });

    if (result.get(RES_YES_OR_NO) === undefined) {
      yes.classList.add(ERROR);
      no.classList.add(ERROR);
    } else {
      yes.classList.remove(ERROR);
      no.classList.remove(ERROR);
    }


    const resultShow = (result) => {


      const allText = document.querySelector('.main__text').querySelectorAll('.text')
      const allList = document.querySelector('.main__list').querySelectorAll('.accordion-container')

      const clearAllText = () => {
        allText.forEach(item => {
          item.classList.remove('block')
        })
      }
      const clearList = () => {
        allList.forEach(item => {
          item.classList.remove('block')
        })
      }

      if (result.get(RES_YES_OR_NO)) {
        document.querySelector('.accordion-container-5').classList.add('block')
        document.querySelector('.accordion-container-6').classList.remove('block')
      } else {
        document.querySelector('.accordion-container-5').classList.remove('block')
        document.querySelector('.accordion-container-6').classList.add('block')
      }

      if (result.get(RES_3) && result.get(RES_1) && result.get(RES_2)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__2').classList.add('block')
        document.querySelector('.accordion-container-2').classList.add('block')

      } else {
        clearAllText()
        clearList()
        document.querySelector('.main__text__4').classList.add('block')
        document.querySelector('.accordion-container-3').classList.add('block')
        document.querySelector('.accordion-container-4').classList.add('block')
      }

      if (!result.get(RES_1) && result.get(RES_2) && result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__3').classList.add('block')
        document.querySelector('.accordion-container-1').classList.add('block')
        document.querySelector('.accordion-container-2').classList.add('block')
      }

      if (result.get(RES_1) && !result.get(RES_2) && result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__2').classList.add('block')
        document.querySelector('.accordion-container-2').classList.add('block')
      }

      if (!result.get(RES_1) && result.get(RES_2) && !result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__2').classList.add('block')
        document.querySelector('.accordion-container-1').classList.add('block')
      }
      if (!result.get(RES_1) && !result.get(RES_2) && result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__5').classList.add('block')
        document.querySelector('.accordion-container-2').classList.add('block')
      }
      if (result.get(RES_1) && result.get(RES_2) && !result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__1').classList.add('block')
        document.querySelector('.accordion-container-1').classList.add('block')
      }
      if (result.get(RES_1) && !result.get(RES_2) && !result.get(RES_3)  ) {
        clearAllText()
        clearList()
        document.querySelector('.main__text__1').classList.add('block')
        document.querySelector('.accordion-container-1').classList.add('block')
      }
    }



    if (result.size === 4) {
      showBug(bugOne, RES_1);
      showBug(bugTwo, RES_2);
      showBug(bugThree, RES_3);
      answerError.classList.remove('active')
      document.querySelector('.answers__container').classList.remove('none')
      resultShow(result);
      if (isTablet()) {
        scrollToAnswer(70);
      }
      if (isMobile()) {
        scrollToAnswer(10);
      }
    } else {
      answerError.classList.add('active')
      document.querySelector('.answers__container').classList.add('none')
    }


  });

  accordionsJs();
};




export function accordionsJs() {
  const item1 = new Accordion('.accordion-container-1', {});
  const item2 = new Accordion('.accordion-container-2', {});
  const item3 = new Accordion('.accordion-container-3', {});
  const item4 = new Accordion('.accordion-container-4', {});
  const item5 = new Accordion('.accordion-container-5', {});
  const item6 = new Accordion('.accordion-container-6', {});
  const doc = document.querySelectorAll('.accordion-container')

  // doc.forEach(item => {
  //   item.
  // })
}
